import React, { ChangeEvent } from 'react'

export interface IProps {
  inputClass?: string
  id?: string
  name?: string
  value: string
  defaultValue?: string
  maxLength?: number
  placeholder?: string
  disabled?: boolean
  rf?: string
  required?: boolean
  onChange: (value: string) => void
}

/**
 * Basic password input
 *
 *
 * @param inputClass (string, optional) - Css input class
 * @param id (string, required) - Input id
 * @param name (string, required) - Input name
 * @param value (string, required) - Contolled input value
 * @param defaultValue (string, optional) - Default value.
 * @param disabled (boolean, optional) - Enable / disable input
 * @param placeholder (string, optional) - Input placeholder
 * @param maxLength (number, optional) - Max length of input value
 * @param onChange (void: string, required) - On change handler
 * @param rf (string, optional) - Optional tracking id fro automated tests
 *
 */
export default function PasswordInput(props: IProps) {

  return (
    <>
      <input
        type='password'
        name={props.name}
        id={props.id}
        className={props.inputClass}
        placeholder={props.placeholder}
        maxLength={props.maxLength}
        value={props.value}
        disabled={props.disabled}
        data-rf={props.rf}
        required={props.required}
        onChange={(e: ChangeEvent<HTMLInputElement>) => props.onChange(e.target.value)}
      />
    </>
  )

}
